<spinner *ngIf="loading"></spinner>

<p *ngIf="loadFailed" role="alert" class="text-danger">The questionnaire could not be loaded. Please reload the page and try again.</p>

<div [hidden]="loading">
    @for (question of questions; track question; let index = $index) {
        <form-field [orderNumber]="question.index" [question]="question" [disabled]="disabled" [questions]="questions" [(parentFormGroup)]="formGroup" [defaultValue]="question.answer"></form-field>
    }
</div>
